import { PayrollRun } from "@wingspanhq/wingspan-api-sdk";

/**
 * The date the contractor list identifies a run by: when it paid out, or when
 * it is due to.
 *
 * This is the v1 rule (`events.paidAt ?? dueDate`) on v3 fields — the retired
 * invoice-backed screen titled every row with it, so a payer recognises a run
 * by its date rather than by its number. `payDate` stands in for the invoice
 * due date: for a run that has not paid yet, it is when it will.
 */
export const selectorPayrollRunDatePaid = (
  payrollRun: PayrollRun
): Date | undefined => payrollRun.events?.paidAt ?? payrollRun.payDate;
